import React from 'react';
import { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import LaptopImg from '../../assets/home-main.svg';
import Tilt from 'react-parallax-tilt';
import mozilla from '../../assets/mozilla.png';
import meraki from '../../assets/meraki.png';
import codeacd from '../../assets/codeac.png';
import NSS from '../../assets/NSS.png';
import laugh from '../../assets/laugh.png';
import tech from '../../assets/TechLearn.png';
import './about.css';
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from 'react-icons/ai';
import { FaLinkedinIn } from 'react-icons/fa';

const About = () => {
  const [currentTooltip, setCurrentTooltip] = useState(null);

  const handleTooltipEnter = (text) => {
    setCurrentTooltip(text);
  };

  const handleTooltipLeave = () => {
    setCurrentTooltip(null);
  };
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: '2.6em' }}>
              LET ME <span className="yellow"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              Hello! I’m  <span className="yellow">Harsh Kushwaha </span> from   <span className="yellow"> Ashta ❤️ </span>, a charming city near Bhopal, MP, India 🇮🇳. I am currently serving as an <span className='yellow'> SDE I</span> (Flutter) at Kuhoo Technology & Services Pvt Ltd.
              <br />
              <br />
              I graduated with a B.Tech from Vellore Institute of Technology in 2024, where I honed my skills in various programming languages and technologies.
              <br />
              As a developer, I thrive on tackling new challenges and continually expanding my expertise.
              <br />
              <br />
              I am proficient in <span className='yellow'>Java, Dart, C++, and JavaScript,</span> and I have a strong passion for <span className='yellow'> Web, Android, and iOS development.</span>  My experience includes working with modern JavaScript libraries and frameworks such as React, Next.js, and Vue.js.
              <br />
              <br />
              Currently, I am deeply interested in app development and exploring new technologies and products. I enjoy creating innovative solutions and am excited about the potential to build impactful applications.
              <br />
            </p>
          </Col>

          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={LaptopImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row className="home-about-social">
          <h1 style={{ fontSize: '2.2em' }}>
            CLUBS <span className="yellow"> & </span> COMMUNITIES
          </h1>
          <p>
            Laughing | Voluntring | Creating | Leading | Learning and{' '}
            <span className="yellow">more.</span>
          </p>
        </Row>
        <div
          className="yellow"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            paddingTop: '20px',
            paddingBottom: '20px',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
            }}
          >
            {/* TechLearn  */}
            <div
              className="tooltip-container"
              onMouseEnter={() => handleTooltipEnter('#Campus Ambassador')}
              onMouseLeave={handleTooltipLeave}
            >
              <img
                src={tech}
                alt=""
                className="img-fluid"
                style={{ maxWidth: '150px' }}
              />
              {currentTooltip === '#Campus Ambassador' && (
                <div className="tooltip-content">{currentTooltip}</div>
              )}
            </div>

            {/* Mozilla Club */}
            <div
              className="tooltip-container"
              onMouseEnter={() =>
                handleTooltipEnter('#Co-Founder & Social Lead')
              }
              onMouseLeave={handleTooltipLeave}
            >
              <img
                src={mozilla}
                alt=""
                className="img-fluid eff"
                style={{ maxWidth: '150px', marginRight: '20px' }}
              />
              {currentTooltip === '#Co-Founder & Social Lead' && (
                <div className="tooltip-content">{currentTooltip}</div>
              )}
            </div>

            {/* Meraki Club */}
            <div
              className="tooltip-container"
              onMouseEnter={() =>
                handleTooltipEnter('#Social Lead & Event Volunteer')
              }
              onMouseLeave={handleTooltipLeave}
            >
              <img
                src={meraki}
                alt=""
                className="img-fluid"
                style={{ maxWidth: '150px', marginRight: '20px' }}
              />
              {currentTooltip === '#Social Lead & Event Volunteer' && (
                <div className="tooltip-content">{currentTooltip}</div>
              )}
            </div>

            {/* Laughing Club */}
            <div
              className="tooltip-container"
              onMouseEnter={() =>
                handleTooltipEnter('#Organizer & Standup Comedian')
              }
              onMouseLeave={handleTooltipLeave}
            >
              <img
                src={laugh}
                alt=""
                className="img-fluid"
                style={{ maxWidth: '150px' }}
              />
              {currentTooltip === '#Organizer & Standup Comedian' && (
                <div className="tooltip-content">{currentTooltip}</div>
              )}
            </div>

            {/* NSS Club */}
            <div
              className="tooltip-container"
              onMouseEnter={() => handleTooltipEnter('#Video Editor')}
              onMouseLeave={handleTooltipLeave}
            >
              <img
                src={NSS}
                alt=""
                className="img-fluid"
                style={{ maxWidth: '150px', marginRight: '20px' }}
              />
              {currentTooltip === '#Video Editor' && (
                <div className="tooltip-content">{currentTooltip}</div>
              )}
            </div>

            {/* CodeAcad Club */}
            <div
              className="tooltip-container"
              onMouseEnter={() => handleTooltipEnter('#Video Editor')}
              onMouseLeave={handleTooltipLeave}
            >
              <img
                src={codeacd}
                alt=""
                className="img-fluid"
                style={{ maxWidth: '150px', marginRight: '20px' }}
              />
              {currentTooltip === '#Video Editor' && (
                <div className="tooltip-content">{currentTooltip}</div>
              )}
            </div>
          </div>
        </div>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Please don't hesitate to reach out to me and {' '}
              <span className="yellow">connect.</span>
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/harsh774"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                  aria-label="github"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://twitter.com/Mr_Harsh23_?t=dBd30uTuWvzwAOis5sdMJw&s=09"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                  aria-label="twitter"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/harsh-singh23"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                  aria-label="linkedin"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/mr_harsh2.3_"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                  aria-label="instagram"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default About;
